import {
  UPDATE_ADDONS_DEPARTURE_EDIT_ORDER,
  UPDATE_ADDONS_RETURN_EDIT_ORDER,
  UPDATE_CABINS_DEPARTURE_EDIT_ORDER,
  UPDATE_CABINS_RETURN_EDIT_ORDER,
  UPDATE_SEARCH_EDIT_ORDER_VALUES,
  CLEAR_EDIT_ORDER_VALUES,
  UPDATE_EDIT_ORDER_VALUES
} from '../types';

export const updateCabinsDepartureEditOrder = (data) => {
  return {
    type: UPDATE_CABINS_DEPARTURE_EDIT_ORDER,
    payload: data,
  };
};

export const updateAddonsDepartureEditOrder = (data) => {
  return {
    type: UPDATE_ADDONS_DEPARTURE_EDIT_ORDER,
    payload: data,
  };
};

export const updateCabinsReturnEditOrder = (data) => {
  return {
    type: UPDATE_CABINS_RETURN_EDIT_ORDER,
    payload: data,
  };
};

export const updateAddonsReturnEditOrder = (data) => {
  return {
    type: UPDATE_ADDONS_RETURN_EDIT_ORDER,
    payload: data,
  };
};

export const updateSearchEditOrderValues = (data) => {
  return {
    type: UPDATE_SEARCH_EDIT_ORDER_VALUES,
    payload: data,
  };
};

export const clearEditOrderValues = () => {
  return {
    type: CLEAR_EDIT_ORDER_VALUES,
  };
};

export const updateEditOrderValues = (data) => {
  return {
    type: UPDATE_EDIT_ORDER_VALUES,
    payload: data,
  };
}